import { faChevronCircleUp } from '@fortawesome/pro-duotone-svg-icons';
import { faChevronCircleDown } from '@fortawesome/pro-solid-svg-icons';

import { Icon, cn } from '@growtherapy/sprout-ui';

export function PopoverChevronIndicator({ isOpen = false, className }: { isOpen?: boolean; className?: string }) {
  return (
    <Icon
      data-testid='popover-button.chevron-icon'
      className={cn(
        'absolute -top-1 -right-1 bg-neutral-100 text-neutral-800 rounded-full rebrand:text-text-default rebrand:bg-surface-default',
        className,
      )}
      icon={isOpen ? faChevronCircleUp : faChevronCircleDown}
    />
  );
}
